import React, { memo, useEffect, useRef, useState, forwardRef, useCallback, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import clsx from "clsx";
import ResizeObserver from "react-resize-observer";

import { FixedSizeList, VariableSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";
import { isMobile } from "react-device-detect";

import { HighlightSpan } from "./PriceBoardTotalMode";
//
import { changeSortConfig, addFavSymbol, removeFavSymbol, changeSelectShowInfo, showPopupInfo, removeFindSymbol, updateParamSearchHisTPRLPopup, showPopupInfoTPRL } from "../redux/actions/sharedActions";

import { formatQtty, formatNumberToM, formatNumber } from "../helpers/utils";
import CandleStickHistChart from "./share-components/CandleStickHistChart";
import StockDerivativeDetail from "./stock-components/StockDerivativeDetail";
import StockMatchDetailV2 from "./stock-components/StockMatchDetailV2";
import { useApiCategoryStock } from "../helpers/apiCategoryStock";
import Moment from 'moment';
import { DateFormat } from "../helpers/constData";

export default memo(function PriceBoardTPRLMode(props) {
  const { symbolInfos } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  //
  const [headerRowPos, setHeaderRowPos] = useState(null);

  const [bidPrice3Pos, setBidPrice3Pos] = useState(null);
  const [bidQtty1Pos, setBidQtty1Pos] = useState(null);

  const [offerPrice1Pos, setOfferPrice1Pos] = useState(null);
  const [offerQtty3Pos, setOfferQtty3Pos] = useState(null);

  const [offerMatchPosStart, setOfferMatchPosStart] = useState(null);
  const [offerMatchPosEnd, setOfferMatchPosEnd] = useState(null);

  const [showTotalValue, setShowTotalValue] = useState(false);

  const marketTPRLInfo = useSelector((state) => state.gBoard.marketTRPLInfo.find((e) => e.boardCode === "ALLMARKET") ?? {});
  const marketTPRLInfo_all = useSelector((state) => state.gBoard.marketTRPLInfo ?? {});

  // console.log(marketTPRLInfo_all, " marketTPRLInfo_all", marketTPRLInfo, "marketTPRLInfo");
  //
  const refHeaderFix = useRef(null);
  const refScrollBody = useRef(null);

  const refBid = useRef(null);
  const refOffer = useRef(null);
  const refMatch = useRef(null);

  const measureRefBid = useCallback((node) => {
    if (node !== null) {
      refBid.current = node;
    }
  }, []);

  //
  const measureRefOffer = useCallback((node) => {
    if (node !== null) {
      refOffer.current = node;
    }
  }, []);

  const measureRefMatch = useCallback((node) => {
    if (node !== null) {
      refMatch.current = node;
    }
  }, []);

  const _handleChangeShowTotalValue = () => {
    if (showTotalValue) {
      setShowTotalValue(false);
    } else {
      setShowTotalValue(true);
    }
  };

  //
  const _handleHeaderScroll = useCallback(
    ({ target }) => {
      const { scrollTop, scrollLeft } = target;
      if (refScrollBody.current) {
        // refScrollBody.current.scrollBody.scrollLeft(scrollLeft);
      }
    },
    [refScrollBody.current]
  );

  const _handleBobyScroll = useCallback(
    ({ target }) => {
      const { scrollTop, scrollLeft } = target;
      refHeaderFix.current.scrollLeft = scrollLeft;
    },
    [refHeaderFix.current]
  );

  const _calcDivBidPosition = () => {
    if (headerRowPos && bidPrice3Pos && bidQtty1Pos && refBid.current) {
      const _left = bidPrice3Pos.x - headerRowPos.x;
      const _width = bidQtty1Pos.x - bidPrice3Pos.x + bidQtty1Pos.width;
      refBid.current.style.left = _left + "px";
      refBid.current.style.width = _width + "px";
    }
  };

  const _calcDivOfferPosition = () => {
    if (headerRowPos && offerPrice1Pos && offerQtty3Pos && refOffer.current) {
      const _left = offerPrice1Pos.x - headerRowPos.x;
      const _width = offerQtty3Pos.x - offerPrice1Pos.x + offerQtty3Pos.width;
      refOffer.current.style.left = _left + "px";
      refOffer.current.style.width = _width + "px";
    }
  };

  const _calcDivMatchPosition = () => {
    if (headerRowPos && offerMatchPosStart && offerMatchPosEnd && refMatch.current) {
      const _left = offerMatchPosStart.x - headerRowPos.x;
      const _width = offerMatchPosEnd.x - offerMatchPosStart.x + offerMatchPosEnd.width;
      refMatch.current.style.left = _left + "px";
      refMatch.current.style.width = _width + "px";
    }
  };

  useEffect(() => {
    _calcDivBidPosition();
  }, [headerRowPos, bidPrice3Pos, bidQtty1Pos, refBid.current]);

  useEffect(() => {
    _calcDivOfferPosition();
  }, [headerRowPos, offerPrice1Pos, offerQtty3Pos, refOffer.current]);

  useEffect(() => {
    _calcDivMatchPosition();
  }, [headerRowPos, offerMatchPosStart, offerMatchPosEnd, refMatch.current]);

  //
  return (
    <>
      <div className="price-board-total" >
        <table>
          <thead>
            <tr>
              <th>Tổng khối lượng giao dịch (TP)</th>
              <th>Tổng giá trị giao dịch (VND)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{marketTPRLInfo.totalPtTradedQtty}</td>
              <td>{marketTPRLInfo.totalPtTradedValue}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <AutoSizer disableHeight>
        {({ height, width }) => {
          return (
            <div style={{ width: width }}>
              <div ref={refHeaderFix} onScroll={_handleHeaderScroll} style={{ width: width, overflowX: "scroll", overflowY: "hidden", marginBottom: isMobile ? 0 : -10 }}>
                <div className="prc-row-head prc-row-head-spec">
                  <ResizeObserver
                    onResize={(rect) => {
                      setHeaderRowPos(rect);
                    }}
                    onPosition={(rect) => {
                      setHeaderRowPos(rect);
                    }}
                    onReflow={(rect) => {
                      setHeaderRowPos(rect);
                    }}
                  />
                  <div className={clsx("mw-95 text-center th-sort bdl-white")}>{t("maTP")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("klPhatHanh")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("laiSuatBanDau")}</div>
                  <div className={clsx("prc-col2 text-center ")}>{t("taiSanDamBao")}</div>
                  <div className={clsx("prc-col2 text-center ")}>{t("kyHanConLai")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("ngayDaoHan")}</div>

                  <div className={clsx("prc-col-rs prc-col2 text-center bdl-white")}>
                    {t("giaCaoNhat")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setBidPrice3Pos(rect);
                      }}
                      onPosition={(rect) => {
                        setBidPrice3Pos(rect);
                      }}
                      onReflow={(rect) => {
                        setBidPrice3Pos(rect);
                      }}
                    />
                  </div>

                  <div className={clsx("prc-col-rs prc-col2 text-center")}>{t("klTaiGiaCaoNhat")}</div>

                  <div className={clsx("prc-col-rs prc-col2 text-center")}>
                    {t("tongKLMuaTPRL")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setBidQtty1Pos(rect);
                      }}
                      onPosition={(rect) => {
                        setBidQtty1Pos(rect);
                      }}
                      onReflow={(rect) => {
                        setBidQtty1Pos(rect);
                      }}
                    />
                  </div>

                  <div ref={measureRefBid} className={"prc-col-cs prc-col-bid bdl-white"}>
                    {t("chaoMuaTPRL")}
                  </div>

                  {/* Khớp */}
                  <div className={clsx("prc-col-rs prc-col2 text-center bdl-white")}>
                    {t("giaThapNhat")}
                    <ResizeObserver
                      onResize={(rect) => {
                        setOfferMatchPosStart(rect);
                      }}
                      onPosition={(rect) => {
                        setOfferMatchPosStart(rect);
                      }}
                      onReflow={(rect) => {
                        setOfferMatchPosStart(rect);
                      }}
                    />
                  </div>
                  <div className={clsx("prc-col-rs prc-col2 text-center")}>{t("klTaiGiaThapNhat")}</div>
                  <div className={clsx("prc-col-rs prc-col2 text-center")}>
                    <ResizeObserver
                      onResize={(rect) => {
                        setOfferMatchPosEnd(rect);
                      }}
                      onPosition={(rect) => {
                        setOfferMatchPosEnd(rect);
                      }}
                      onReflow={(rect) => {
                        setOfferMatchPosEnd(rect);
                      }}
                    />{t("Tổng KL")}</div>

                  <div ref={measureRefMatch} className={" prc-col-cs prc-col-match bdl-white"}>
                    {t("chaoBanTPRL")}
                  </div>

                  {/* END khớp */}
                  <div className={clsx("prc-col2 text-center bdl-white")}>{t("giaTHGanNhat")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("klTaiGiaTHGanNhat")}</div>

                  <div className={clsx("prc-col2 text-center")}>{t("giaThCaoNhat")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("klTaiGiaTHCaoNhat")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("giaTHThapNhat")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("klTaiGiaTHThapNhat")}</div>
                  <div className={clsx("prc-col2 text-center")}>{t("tongKLGD")}</div>
                  <div className={clsx("prc-col3 text-center")}>{t("tongGTGD")}</div>
                </div>
              </div>
            </div>
          );
        }}
      </AutoSizer>
      <div className={"price-board"}>
        <TableBody ref={refScrollBody} symbolInfos={symbolInfos} onScroll={_handleBobyScroll} showTotalValue={showTotalValue} />
      </div>
    </>
  );
});

//
const TableBody = forwardRef((props, ref) => {
  //
  const { symbolInfos, onScroll, showTotalValue } = props;
  //
  const dispatch = useDispatch();
  const findSymbol = useSelector((state) => state.gShared.findSymbol);
  //
  const refTable = useRef(null);
  const refScroll = useRef(null);

  useImperativeHandle(ref, () => ({
    scrollBody: refScroll.current,
    scrollToItem: (itemIdx) => {
      if (refTable.current) {
        refTable.current.scrollToItem(itemIdx);
      }
    },
  }));
  //
  const _handleScroll = useCallback(
    ({ target }) => {
      const { scrollTop, scrollLeft } = target;
      if (refTable.current) {
        refTable.current.scrollTo(scrollTop);
      }
      //
      if (onScroll) {
        try {
          onScroll({ target });
        } catch (error) { }
      }
    },
    [refTable.current]
  );

  const _handleTableScroll = useCallback(
    ({ scrollDirection, scrollOffset, scrollUpdateWasRequested }) => {
      if (refScroll.current) {
        refScroll.current.scrollTop(scrollOffset);
      }
      if (findSymbol && findSymbol.code && findSymbol.code !== "") {
        removeFindSymbol(dispatch, "");
      }
    },
    [refScroll.current]
  );

  const _scrollToSymbol = () => {
    if (refTable.current) {
      if (findSymbol && findSymbol.code && findSymbol.code !== "" && symbolInfos && symbolInfos.length > 0) {
        const _idx = symbolInfos.findIndex((e) => e.code === findSymbol.code);
        if (_idx >= 0) {
          if (refTable.current) {
            refTable.current.scrollToItem(_idx, "start");
          }
        }
      }
    } else {
      setTimeout(() => {
        _scrollToSymbol();
      }, 100);
    }
  };

  useEffect(() => {
    _scrollToSymbol();
  }, [findSymbol.counter, symbolInfos.length]);

  //
  return (
    <AutoSizer>
      {({ height, width }) => {
        return (
          <Scrollbars
            ref={refScroll}
            autoHide={true}
            autoHeight={true}
            autoHeightMax={height}
            onScroll={_handleScroll}
            style={{ width: width }}
            renderTrackHorizontal={(props) => <div {...props} className="scroll-track-horizontal" />}
            renderTrackVertical={(props) => <div {...props} className="scroll-track-vertical" />}
            renderThumbHorizontal={(props) => <div {...props} className="scroll-thumb-horizontal" />}
            renderThumbVertical={(props) => <div {...props} className="scroll-thumb-vertical" />}
            renderView={(props) => <div {...props} className="scroll-view" />}
            className={"scroll-container"}>
            <ScrollContent symbolInfos={symbolInfos} height={height} onScroll={_handleTableScroll} showTotalValue={showTotalValue} ref={refTable} />
          </Scrollbars>
        );
      }}
    </AutoSizer>
  );
});

//
const ScrollContent = memo(
  forwardRef(function (props, ref) {
    const { symbolInfos, height, onScroll, showTotalValue } = props;
    //

    const [selectedRow, setSelectedRow] = useState(null); // Trạng thái để theo dõi dòng được chọn

    const handleRowClick = (index) => {
      if (selectedRow === index) {
        setSelectedRow(null); // Nếu click vào dòng đã chọn, ẩn div đi
      } else {
        setSelectedRow(index); // Nếu click vào dòng mới, hiển thị div mới
      }
    };

    const itemSizes = Array.from({ length: symbolInfos.length }, (_, index) => {
      ref?.current?.resetAfterIndex(0);
      return selectedRow === index ? 390 : 28;
    });

    return (
      <>
        <VariableSizeList ref={ref} height={height} width={"100%"} itemCount={symbolInfos.length} itemSize={(index) => itemSizes[index]} style={{ overflow: false }} onScroll={onScroll}>
          {({ index, style }) => {
            const _symbolInfo = symbolInfos[index];
            return (
              <div>
                <RowFlex
                  className={"prc-row " + (index % 2 === 0 ? "odd" : "even")}
                  counter={_symbolInfo.counter ?? 0}
                  code={_symbolInfo.code}
                  showTotalValue={showTotalValue}
                  rowClick={() => handleRowClick(index)}
                  style={{ ...style }}
                  selectedRow={selectedRow}
                  index={index}
                />
                {/* {console.log(selectedRow, indkex, itemSizes[index], itemSizes, "selectedRow trong VariableSizeList")} */}
              </div>
            );
          }}
        </VariableSizeList>
      </>
    );
  })
);

//
const RowFlex = memo(function (props) {
  const { code, showTotalValue } = props;
  //
  const dispatch = useDispatch();
  const prevSymbolCode = useRef(""); // .current

  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState("1");

  const tabIsFocus = useSelector((state) => state.gShared.tabIsFocus);
  const counter = useSelector((state) => state.gSymbol.symbolTPRLInfos.find((e) => e.code === code).counter);
  const symbolInfo = useSelector((state) => state.gSymbol.symbolTPRLInfos.find((e) => e.code === code));
  const priceBoardFavSymbols = useSelector((state) => state.gShared.priceBoardFavSymbols);
  const apiCategoryStock = useApiCategoryStock();
  const currentCategory = useSelector((state) => state.gShared.currentCategory) ?? [];
  const categoryStocks = useSelector((state) => state.gShared.categoryStocks) ?? [];
  const priceBoardIsOddlot = useSelector(state => state.gShared.priceBoardIsOddlot);
  const lastSymbol = useSelector((state) => state.gShared.lastSymbol);

  const _fireEvent = prevSymbolCode.current === symbolInfo.code && tabIsFocus;
  //
  const _handleRowClick = useCallback((event, code) => {
    if (code) {
      if (code + "_code" === event.target.id) {
        showPopupInfoTPRL(dispatch, "POPUP_TPRL", code);

        //lưu thông tin ban đầu search "Lịch sử giá"
        updateParamSearchHisTPRLPopup(dispatch, {
          tradingDateFrom: Moment().format(DateFormat.YYYYMMDD),
          tradingDateTo: Moment().format(DateFormat.YYYYMMDD),
          code: code,
        });

      } else if (code + "_star" === event.target.id) {
        //
      } else {
        changeSelectShowInfo(dispatch, "ST", code);
      }
    }
  }, []);
  //
  const getCategoryStock = async () => {
    const { data: loaded } = await apiCategoryStock.CategoryStock();
    dispatch({
      type: "GET_CATEGORY_STOCK",
      payload: loaded.arrCata,
    });
  };

  useEffect(() => {
    prevSymbolCode.current = symbolInfo.code;
  }, [symbolInfo.code]);

  const changeFavSymbol = (checked, code) => {
    if (checked) {
      _addFavSymbol(code);
    } else {
      _removeFavSymbol(code)
    }
  }

  const _addFavSymbol = useCallback((code) => {
    addFavSymbol(dispatch, code);
  }, [])

  const _removeFavSymbol = useCallback((code) => {
    removeFavSymbol(dispatch, code);

    handleRemoveStockIntoCategory(code)
  }, [])

  const handleRemoveStockIntoCategory = async (code) => {
    await apiCategoryStock.EditGroupStock({ lstid: currentCategory, code: code, type: "D" })
      .then((res) => {
        if (res.status === 200) {
          // setSearchValue("");
        }
      })
      .catch((err) => {
        console.log("err => ", err);
      })
      .finally(() => {
        getCategoryStock();
      });
  };

  return (
    <>
      <div onClick={(event) => _handleRowClick(event, symbolInfo.code)} className={`${props.className} ${lastSymbol === symbolInfo.code ? "lastSymbol" : ""}`} style={{ ...props.style }}>
        <div className="mw-95 text-center has-symbol d-flex jtf-start pl-1" title={symbolInfo.code + " - " + (symbolInfo.symbolName ?? '') + " - " + symbolInfo.marketName} >
          <input type="checkbox" onChange={(e) => changeFavSymbol(e.target.checked, symbolInfo.code)} checked={priceBoardFavSymbols.includes(symbolInfo.code) || categoryStocks.filter(e => e.listid === currentCategory)[0]?.code?.split(',').includes(symbolInfo.code)} />
          <span style={{ cursor: 'pointer', marginLeft: '6px' }} id={symbolInfo.code + "_code"} className={symbolInfo.pt_MatchPrice_color}>{symbolInfo.code}{(symbolInfo.referenceStatus && symbolInfo.referenceStatus !== '' && symbolInfo.referenceStatus !== '0' ? "*" : "")}</span>
        </div>
        <div className={clsx("prc-col2 text-right")}>{symbolInfo.totalListingQtty}</div>
        <div className="prc-col2 text-right bg-smoke">
          <HighlightSpan id={symbolInfo.code + "_interestRate"} value={symbolInfo.interestRate} fireEvent={_fireEvent} />
        </div>

        <div className="prc-col2 text-left bg-smoke text-right">
          <HighlightSpan id={symbolInfo.code + "_tsdb"} value={symbolInfo.tsdb === 'Y' ? t("co") : t("khong")} fireEvent={_fireEvent} />
        </div>

        <div className="prc-col2 text-right bg-smoke">
          <HighlightSpan id={symbolInfo.code + "_periodRemain"} value={symbolInfo.periodRemain} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col2 text-center")}>
          <HighlightSpan id={symbolInfo.code + "_maturitDate"} value={symbolInfo.maturitDate} fireEvent={_fireEvent} />
        </div>

        {/* Chào mua  */}
        <div className={clsx("prc-col2 text-right bdl-white", symbolInfo.pt_BestBidPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_BestBidPrice"} value={symbolInfo.pt_BestBidPrice} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right", symbolInfo.pt_BestBidQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_BestBidQtty"} value={symbolInfo.pt_BestBidQtty} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right", symbolInfo.pt_TotalBidQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_bpt_TotalBidQtty"} value={symbolInfo.pt_TotalBidQtty} fireEvent={_fireEvent} />
        </div>

        {/* Chào bán */}
        <div className={clsx("prc-col2 text-right bdl-white", symbolInfo.pt_BestOfferPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_BestOfferPrice"} value={symbolInfo.pt_BestOfferPrice} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right", symbolInfo.pt_BestOfferQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_BestOfferQtty"} value={symbolInfo.pt_BestOfferQtty} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right bg-smoke ", symbolInfo.pt_TotalOfferQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_TotalOfferQtty"} value={symbolInfo.pt_TotalOfferQtty} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col2 text-right bg-smoke bdl-white", symbolInfo.pt_MatchPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_MatchPrice"} value={symbolInfo.pt_MatchPrice} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col2 text-right bg-smoke", symbolInfo.pt_MaxQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_MaxQtty"} value={symbolInfo.pt_MaxQtty} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right ", symbolInfo.pt_MaxPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_MaxPrice"} value={symbolInfo.pt_MaxPrice} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col2 text-right", symbolInfo.pt_MaxQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_MaxQtty"} value={symbolInfo.pt_MaxQtty} fireEvent={_fireEvent} />
        </div>

        <div className={clsx("prc-col2 text-right", symbolInfo.pt_MinPrice_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_MinPrice"} value={symbolInfo.pt_MinPrice} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right", symbolInfo.pt_MinQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_MinQtty"} value={symbolInfo.pt_MinQtty} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col2 text-right", symbolInfo.pt_TotalTradedQtty_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_TotalTradedQtty"} value={symbolInfo.pt_TotalTradedQtty} fireEvent={_fireEvent} />
        </div>
        <div className={clsx("prc-col3 text-right", symbolInfo.pt_TotalTradedValue_color)}>
          <HighlightSpan id={symbolInfo.code + "_pt_TotalTradedValue"} value={symbolInfo.pt_TotalTradedValue} fireEvent={_fireEvent} />
        </div>

      </div>
    </>
  );
});
